module.controller('signupConfirmationCtrl', ['signupOrderDataService', 'authService', 'LimitsService', '$q', '$state',
  function(signupOrderDataService, authService, LimitsService, $q, $state) {

  var vm = this;

  vm.orderData = signupOrderDataService.get();
  vm.goTo = goTo;

  ///////////////////////////////

  function goTo(state) {
    $q.all([
      authService.checkStatus(),
      authService.getFeatureAccess(),
      LimitsService.update()
    ]).then(function(results){

      try {
        // set status and feature access
        authService.setStatusSession(results[0].data);
        authService.setFeatureAccessSession(results[1].data);
      } catch (e) {
        Rollbar.error(e);
      }

      $state.go(state);

    }).catch(function(err){
      Rollbar.error(err);
    });
  }

}]);
